import { LocationWM } from "../weedmaps/location";

export type Context = {
  [key: string]:
    | string
    | number
    | boolean
    | null
    | undefined
    | Array<string | boolean | number>;
};
export class SegmentWM {
  pageContext: Context = {};
  locationWM: LocationWM = new LocationWM();
  locationEnabled: boolean = false;
  /**
   * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track
   */
  track(eventName: string, properties = {}) {
    analytics.track(eventName, properties);
  }

  /**
   * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
   */
  page(name: string, params: any = {}) {
    analytics.page(name, this.propertiesBuilder(params));
  }

  /**
   * Ensures that page context is injected in the request.
   */
  propertiesBuilder(params = {}) {
    return { ...this.pageContext, ...params };
  }

  /**
   * Creates the event payload for click events.
   * @param {*} elem
   * @param String type
   * @param {String | Null} forcedName
   */
  trackClickPropertiesBuilder(
    elem: HTMLElement,
    type: string,
    forcedName = ""
  ) {
    const $elem = jQuery(elem);
    const params: { [key: string]: any } = {
      text: $elem.attr("data-segment-text") || $elem.text(),
      name: forcedName || $elem.attr("data-segment-name") || "unknown",
      destination: $elem.attr("href"),
      navigation: $elem.attr("data-segment-navigation"),
      type: type.toLowerCase(),
      section: $elem.attr("data-segment-section"),
    };

    // TODO: figure out what this stuff is for
    // jQuery.each($elem.data(), function (key, value) {
    //   const segmentPrefix = "segment_";
    //   const contextPrefix = "context_";

    //   if (key.indexOf(segmentPrefix) !== -1) {
    //     return true;
    //   }

    //   key = key
    //     .split(/(?=[A-Z])/)
    //     .join("_")
    //     .toLowerCase()
    //     .replace(segmentPrefix, "");

    //   if (reservedKeys.indexOf(key) === -1) {
    //     params[contextPrefix + key] = value;
    //   }
    // });

    Object.keys(params).forEach((key) => {
      params[key] && typeof params[key] === "string" && params[key].trim();
    });

    return this.propertiesBuilder(params);
  }

  /**
   *  https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
   * @param { scopeSelector: String, addElementSelector: String }
   *      scopeSelector      - adds a selector to scope the default [data-segment-link] element
   *      addElementSelector - adds a selector to the default [data-segment-link] element
   */
  addLinkClickEventListeners({
    scopeSelector = "",
    addElementSelector = "",
  } = {}) {
    jQuery(`${scopeSelector} ${addElementSelector}[data-segment-link]`).each(
      (_idx: number, elem: HTMLElement) => {
        analytics.trackLink(
          elem,
          "Element Clicked",
          this.trackClickPropertiesBuilder(elem, "link")
        );
      }
    );
  }

  /**
   * @param { scopeSelector: String, addElementSelector: String }
   *      scopeSelector      - adds a selector to scope the default [data-segment-link] element
   *      addElementSelector - adds a selector to the default [data-segment-link] element
   */
  addButtonClickEventListeners({
    scopeSelector = "",
    addElementSelector = "",
  } = {}) {
    jQuery(`${scopeSelector} ${addElementSelector}[data-segment-button]`).each(
      (_idx: number, elem: HTMLElement) => {
        // remove existing segment click event if already exists for some reason to avoid duplicates
        jQuery(elem).off("click.segment");
        jQuery(elem).on("click.segment", (event) => {
          this.track(
            "Element Clicked",
            this.trackClickPropertiesBuilder(event.currentTarget, "button")
          );
        });
      }
    );
  }

  /**
   * scopeSelector - adds a selector to scope the element to a parent
   * addElementSelector - adds a selector to the element itself
   */
  addArticleClickEventListeners({
    scopeSelector = "",
    addElementSelector = "",
  } = {}) {
    jQuery(`${scopeSelector} ${addElementSelector}[data-segment-article]`).each(
      (_idx, elem: HTMLElement) => {
        const $elem = jQuery(elem);

        const params: Context = {
          article_id: parseInt($elem.attr("data-segment-article-id") || "", 10),
          article_name: $elem.attr("data-segment-article-name"),
          article_slug: $elem.attr("data-segment-article-slug"),
          article_type: $elem.attr("data-segment-article-type"),
        };

        const section = $elem.attr("data-segment-section");
        if (section) {
          params["section_name"] = section;
        }

        const position = $elem.attr("data-segment-position");
        if (position) {
          params["position"] = parseInt(position, 10);
        }

        analytics.trackLink(
          elem,
          "Article Clicked",
          this.propertiesBuilder(params)
        );
      }
    );
  }

  addSubMenuClickEventListeners({
    scopeSelector = "",
    addElementSelector = "",
  } = {}) {
    jQuery(".divimegapro a img").click(
      (_idx) => {
        _idx.preventDefault();
        let id = _idx.target.closest('[id]');
        let menuURL = _idx.target.closest('a').href;
        let menuText = jQuery(".divimegapro-" + id.dataset.dmpcid + " a").eq(0).text();
        menuText = (menuText.includes('For'))? menuText.replace('For ', '') : menuText ;
        let imgWmTitle = _idx.target.title;
        let wmTitle = imgWmTitle.toLowerCase().slice(3);

        const params: Context = {
          name: menuText,
          text: "wm " + wmTitle,
          type: "navigation",
          section_name: menuText + " submenu"
        };

        analytics.track("Element Clicked", this.propertiesBuilder(params));

        var smForm = jQuery('<form>', {
            action: menuURL,
            method: 'get'
        });

        jQuery('<input>').attr({
            type: "hidden",
            name: "contextExperience",
            value: menuText
        }).appendTo(smForm);

        jQuery('<input>').attr({
            type: "hidden",
            name: "contextBusinessType",
            value: wmTitle
        }).appendTo(smForm);

        smForm.appendTo('body').submit();
      }
    );
  }

  addMenuClickEventListeners({
    scopeSelector = "",
    addElementSelector = "",
  } = {}) {
    jQuery(".menu-item a").click(
      (_idx) => {
        let menuText = _idx.target.innerText;
        menuText = menuText.toLowerCase();

        const params: Context = {
          name: "page navigation",
          text: menuText,
          type: "navigation",
          section_name: "header"
        };

        analytics.track("Element Clicked", this.propertiesBuilder(params));
      }
    );
  }

  hydrateRegionPageContext() {
    const sales = this.locationWM.salesRegion || undefined;
    const brand = this.locationWM.brandRegion || undefined;
    const locationDetails = this.locationWM.locationDetails || undefined;
    const latLng = this.locationWM.latLng || undefined;

    Object.assign(this.pageContext, {
      context_region_name: sales?.name || null,
      context_region_slug: sales?.slug || null,
      context_region_id: sales?.id || null,
      context_region_path: sales?.region_path || null,
      context_brand_region_name: brand?.name || null,
      context_brand_region_id: brand?.id || null,
      context_brand_region_path: brand?.region_path || null,
      context_event_user_latitude: latLng.latitude || null,
      context_event_user_longitude: latLng.longitude || null,
      context_event_user_zipcode: locationDetails.zipcode || null,
      context_event_user_city: locationDetails.city || null,
      context_event_user_state_abv: locationDetails.state_abv || null,
      context_event_user_country: locationDetails.country || null,
      context_event_user_country_code: locationDetails.country_code || null,
    });
  }

  initializeLocation() {
    return this.locationEnabled
      ? this.locationWM.initialize()
      : Promise.resolve(true);
  }

  constructor(pageContext: Context, locationEnabled: boolean) {
    analytics.ready(() => {
      this.pageContext = pageContext;
      this.locationEnabled = locationEnabled;
      this.initializeLocation().finally(() => {
        this.hydrateRegionPageContext();
        this.addLinkClickEventListeners();
        this.addButtonClickEventListeners();
        this.addArticleClickEventListeners();
        this.page((pageContext?.context_event_location as string) || "");
        if(WEEDMAPS__SITE === 'business'){
          this.addSubMenuClickEventListeners();
          this.addMenuClickEventListeners();
        }
      });
    });
  }
}
